"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint complexity: 0 */

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    offersTeaserSpan: {
      direction: 'ltr',
      margin: '8px'
    },
    root: {
      '&.mobile': {},
      backgroundColor: theme.palette.background.paper,
      border: "1px solid ".concat(_helpers.agentDeveloperUtils.getSecondaryColor(100)),
      borderRadius: 10,
      color: theme.palette.primary.main,
      position: 'relative',
      width: '100%'
    }
  };
});
var OffersTeaser = function OffersTeaser() {
  var classes = useStyles();
  var offersTeaser = _helpers.agentDeveloperUtils.getOffersTeaser;
  if (!offersTeaser || !offersTeaser.text) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    name: "offer-teaser-span-container",
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.offersTeaserSpan,
    name: "offer-teaser-span"
  }, offersTeaser.icon, /*#__PURE__*/_react.default.createElement("span", null, offersTeaser.text), offersTeaser.moreDetails ? /*#__PURE__*/_react.default.createElement("a", {
    style: {
      marginRight: '6px'
    },
    href: offersTeaser.moreDetails.href,
    target: "_blank",
    rel: "noreferrer"
  }, offersTeaser.moreDetails.text) : null));
};
var _default = exports.default = OffersTeaser;